import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"
import { P } from "../typography"
import {
  Container,
  Skills,
  Skill,
  Media,
  Text,
  Img,
  Logo,
  PlayButton,
  Banner,
  StyledH3,
  InterviewButton,
  Div,
  SvgDiv
} from "./styles"

class Employer extends Component {
  render() {
    const { employer, toggleProfile } = this.props

    let skills = []
    let skillsFromEmployer = employer.skills || []

    skillsFromEmployer.forEach(function (skill) {
      const i = skills.findIndex((x) => x.name === skill.name)
      if (i <= -1) skills.push(skill)
    })
    const skillsToDisplay = skills.slice(0, 5)
    const remainingSkills = skills.slice(5)

    return (
      <Container onClick={(event) => toggleProfile && toggleProfile(event, employer.id)} pointer={!!toggleProfile}>
        <Media>
          {employer.interviews_available && <Banner>Online interviews available</Banner>}
          {employer.interviews_available_via_event && <Banner>Interviews available at hiring fair</Banner>}
          <Img src={employer.header_image_url} alt={employer.name} />
          <Logo src={employer.logo_url} alt={employer.name} />
          <Div>
            <SvgDiv>
              {employer.interviews_available && toggleProfile && (
                <InterviewButton
                  width="42"
                  height="42"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={(event) => toggleProfile(event, employer.id, "roles")}
                >
                  <path
                    d="M7 4C7.41563 4 7.75 4.33437 7.75 4.75V6H12.25V4.75C12.25 4.33437 12.5844 4 13 4C13.4156 4 13.75 4.33437 13.75 4.75V6H15C16.1031 6 17 6.89688 17 8V8.5V10H16.5H15.5H12H4.5V18C4.5 18.275 4.725 18.5 5 18.5H11.8906C12.275 19.0875 12.7656 19.5969 13.3375 20H5C3.89688 20 3 19.1031 3 18V10V8.5V8C3 6.89688 3.89688 6 5 6H6.25V4.75C6.25 4.33437 6.58437 4 7 4ZM12 15.5C12 14.3065 12.4741 13.1619 13.318 12.318C14.1619 11.4741 15.3065 11 16.5 11C17.6935 11 18.8381 11.4741 19.682 12.318C20.5259 13.1619 21 14.3065 21 15.5C21 16.6935 20.5259 17.8381 19.682 18.682C18.8381 19.5259 17.6935 20 16.5 20C15.3065 20 14.1619 19.5259 13.318 18.682C12.4741 17.8381 12 16.6935 12 15.5ZM16.5 13C16.225 13 16 13.225 16 13.5V15.5C16 15.775 16.225 16 16.5 16H18C18.275 16 18.5 15.775 18.5 15.5C18.5 15.225 18.275 15 18 15H17V13.5C17 13.225 16.775 13 16.5 13Z"
                    fill="white"
                  />
                </InterviewButton>
              )}
            </SvgDiv>
            <SvgDiv>
              {employer.video_url && toggleProfile && (
                <PlayButton
                  width="42"
                  height="42"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={(event) => toggleProfile(event, employer.id, "photos_and_videos")}
                >
                  <path
                    d="M10 5.5C9.725 5.5 9.5 5.725 9.5 6V13C9.5 13.2719 9.71563 13.4937 9.9875 13.5L12.1469 10.5563C12.2875 10.3625 12.5125 10.25 12.7531 10.25C12.9938 10.25 13.2156 10.3625 13.3594 10.5563L13.875 11.2625L15.625 8.5875C15.7625 8.375 16 8.24687 16.2531 8.24687C16.5063 8.24687 16.7438 8.375 16.8813 8.5875L20.0844 13.4937C20.3219 13.4531 20.5 13.2469 20.5 13V6C20.5 5.725 20.275 5.5 20 5.5H10ZM8 6C8 4.89688 8.89688 4 10 4H20C21.1031 4 22 4.89688 22 6V13C22 14.1031 21.1031 15 20 15H10C8.89688 15 8 14.1031 8 13V6ZM6.25 8H7V9.5V12.25V15.75V16V18.5H13V16H14.5V18.5H16C16.275 18.5 16.5 18.275 16.5 18V16H18V18C18 19.1031 17.1031 20 16 20H14.5H13.75H13H7H6.25H5.5H4C2.89688 20 2 19.1031 2 18V10C2 8.89688 2.89688 8 4 8H5.5H6.25ZM5.5 9.5H4C3.725 9.5 3.5 9.725 3.5 10V11.5H5.5V9.5ZM5.5 18.5V16.5H3.5V18C3.5 18.275 3.725 18.5 4 18.5H5.5ZM3.5 15H5.5V13H3.5V15ZM11.5 6.5C11.7652 6.5 12.0196 6.60536 12.2071 6.79289C12.3946 6.98043 12.5 7.23478 12.5 7.5C12.5 7.76522 12.3946 8.01957 12.2071 8.20711C12.0196 8.39464 11.7652 8.5 11.5 8.5C11.2348 8.5 10.9804 8.39464 10.7929 8.20711C10.6054 8.01957 10.5 7.76522 10.5 7.5C10.5 7.23478 10.6054 6.98043 10.7929 6.79289C10.9804 6.60536 11.2348 6.5 11.5 6.5Z"
                    fill="white"
                  />
                </PlayButton>
              )}
            </SvgDiv>
          </Div>
        </Media>
        <Text>
          <P variant="primary" size="small">
            {employer.location && `${employer.location} \u00b7 `}
            {employer.employer_type}
          </P>
          <StyledH3 variant="content">{employer.name}</StyledH3>
          <P variant="contentv2">
            {!!employer.camp_counselors && "Camp Counselors \u00b7 "}
            {!!employer.support_staff && "Support Staff \u00b7 "}
            {!!employer.staff_gender && `${employer.staff_gender} \u00b7 `}
            {!!employer.staff_minimum_age && `${employer.staff_minimum_age}+`}
            {!!employer.number_of_campers && ` \u00b7 ${employer.number_of_campers} campers`}
          </P>
          {skillsToDisplay.length > 0 && (
            <Fragment>
              <P variant="primary" marginless size="small">
                Roles available:
              </P>
              <Skills>
                {skillsToDisplay.map((skill) => (
                  <Skill key={`employer_${employer.id}_skill_${skill.id}`}>{skill.name}</Skill>
                ))}
                {remainingSkills.length > 0 && (
                  <Skill key={`employer_${employer.id}_skills_remaining`}>{`+ ${remainingSkills.length} more`}</Skill>
                )}
              </Skills>
            </Fragment>
          )}
        </Text>
      </Container>
    )
  }
}

Employer.propTypes = {
  employer: PropTypes.object.isRequired,
  toggleProfile: PropTypes.func.isRequired,
  skipLinks: PropTypes.bool
}

Employer.defaultProps = {
  skipLinks: false
}

export default Employer
